import { Component, Input } from '@angular/core';
import { FormControl } from "@angular/forms";
import { inOutAnimation } from "../../animations";

@Component({
  selector: 'psc-input-error',
  templateUrl: './input-error.component.html',
  animations: [inOutAnimation({translationPercentage: -15, duration: 0.3})],
})
export class InputErrorComponent {

  @Input() control: FormControl;
  @Input() format: string;
  @Input() formatText: string;
}
